
export function fileName(path) {
    return path
        ? path.split('/').pop()
        : null;
}